module.exports = __webpack_public_path__ + "img/2_139.92477ef1.png";